import i18n from 'i18next';

export const getTimeElapsedString = (timestamp: number | null): string => {
    if (!timestamp) return i18n.t('dashboardPage.neverUpdated');

    const now = Date.now();
    const diffInMs = now - timestamp;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

    if (diffInMinutes < 1) {
        return i18n.t('dashboardPage.justNow');
    } else if (diffInMinutes === 1) {
        return i18n.t('dashboardPage.updated1MinAgo');
    } else {
        return i18n.t('dashboardPage.updatedMinutesAgo', {
            minutes: diffInMinutes,
        });
    }
};
